import React, { useEffect, useRef, useState } from 'react';
import './myrewards.css';
import Modal from 'react-modal';
import { RxCross2 } from 'react-icons/rx';
import { MdKeyboardArrowRight } from 'react-icons/md';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"; // Import the CSS for styling
import { Link } from 'react-router-dom';
import { MdKeyboardArrowDown } from "react-icons/md";
import Cookies from "js-cookie";
import storage from "../../../../Storage";
import { API } from '../../../../Helper';

const getUID = () => parseFloat(Cookies.get("uid"));


const MyRewards = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpen1, setModalOpen1] = useState(false);
  const [activeTab, setActiveTab] = useState('commission'); 
  const [startDate, setStartDate] = useState(null);  
  const [endDate, setEndDate] = useState(null); 
  const [historyModal, setHistoryModal] = useState(false);

    const [token] = useState(storage.getKey('token') || null);
    const [uid] = useState(getUID()); // Get UID immediately from cookie
    const [logged, setLogged] = useState(false);
    const [betLevelCommisson, setBetLevelCommisson] = useState([]);
    const [depositLevelCommisson, setDepositLevelCommisson] = useState([]);
    const [members, setMembers] = useState([]);
   

  const handleHistoryClick = () => {
    setHistoryModal(!historyModal);
  };

  const toggleModal1 = () => {
    setModalOpen1(!isModalOpen1);
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);  
  };

  const dropdownRef = useRef(null);
  
  const [selectedOption, setSelectedOption] = useState("Commission Rewards");
    const [isOptionsVisible, setIsOptionsVisible] = useState(false);
     const [rewards, setRewards] = useState({});
     const [userInfo, setUserInfo] = useState({});

  const options = [
    { label: "Commission Rewards"},
    { label: "Refferal Rewards"}
  ];

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    setIsOptionsVisible(false);
  };

  const toggleOptions = () => {
    setIsOptionsVisible(!isOptionsVisible);
  };

  
  useEffect(() => {
    const selectedGamePercent = options.find(
      (option) => option.label === selectedOption
    )
  }, [ selectedOption]);


   useEffect(() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          
          if (token !== null) {
              setLogged(true);
          }
  
          // Fetch all data immediately
          fetchAllData();
      }, []);
  
      const fetchAllData = () => {
        getDepositLevelCommissionHistory();
        getBetLevelCommissionHistory();
      };

  
      const getDepositLevelCommissionHistory = () => {
          fetch(`${API}/api/deposit-bonus-level-history/${uid}`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json'
              },
          })
          .then(response => response.json())
          .then(data => {
              if (data?.data) {
                setDepositLevelCommisson(data?.data);
                  console.log(data)
              }
          })
          .catch(error => console.log("error", error));
      };
      const getBetLevelCommissionHistory = () => {
          fetch(`${API}/api/bet-bonus-level-history/${uid}`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json'
              },
          })
          .then(response => response.json())
          .then(data => {
              if (data?.data) {
                  setBetLevelCommisson(data?.data);
                  console.log(data)
              }
          })
          .catch(error => console.log("error", error));
      };


          useEffect(() => {
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              
              if (token !== null) {
                  setLogged(true);
              }
      
              // Fetch all data immediately
              fetchAllData();
              getTodayRewards();
              getMyProfile();
              getMembers();
          }, []);
      
          const getTodayRewards = () => {
              fetch(`${API}/api/myAffiliate/${uid}?filter=all`, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  },
              })
              .then(response => response.json())
              .then(data => {
                  if (data) {
                      setRewards(data);
                      console.log("myAffiliate", data)
                  }
              })
              .catch(error => console.log("error fetching today's rewards", error));
          };
      
          const getMyProfile = () => {
              fetch(`${API}/api/myproifle/${uid}`, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  },
              })
              .then(response => response.json())
              .then(data => {
                  if (data?.data) {
                      setUserInfo(data?.data[0]);
                      // console.log(data)
                  }
              })
              .catch(error => console.log("error", error));
          };

          const getMembers = () => {
            fetch(`${API}/api/members/${uid}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then(response => response.json())
            .then(data => {
                setMembers(data.members);
                console.log(data)
            })
            .catch(error => console.log("error fetching members", error));
        };

          const refferalcodeData = [
            {
              username: "JohnDoe",
              userId: "12345",
              commissionRate: "5%",
              totalDeposits: "$500",
              registrationDate: "2024-01-15",
              totalCommission: "$25",
            },
            {
              username: "JaneSmith",
              userId: "67890",
              commissionRate: "4%",
              totalDeposits: "$700",
              registrationDate: "2024-01-10",
              totalCommission: "$28",
            },
            {
              username: "MikeBrown",
              userId: "54321",
              commissionRate: "6%",
              totalDeposits: "$600",
              registrationDate: "2023-12-20",
              totalCommission: "$36",
            },
            {
              username: "EmilyWhite",
              userId: "98765",
              commissionRate: "3.5%",
              totalDeposits: "$800",
              registrationDate: "2023-12-25",
              totalCommission: "$28",
            },
          ];


  return (
    <div>
      <div className="myrewards-main-container">
        <div className="available-commission-refferal-rewards">
          <div className="available-commission-rewards">
            <div className="available-commission-rewards-top">
              <span>Bet Commission</span>
              <div
                onClick={toggleModal}
                className="available-commission-rewards-rules"
              >
                <img src="/assets/bcimages/bcaffiliate/alert-icon.svg" />
              </div>
            </div>
            <span className="available-commission-rewards-amount">
              ${rewards?.betLevelBonusAmount}
            </span>
            {/* <div className='available-commission-rewards-bottom'>
              <span className='commission-rewards-bottom-title'>Total Recieved</span>
              <span className='commission-rewards-bottom-amount'>$0.00</span>
            </div> */}
          </div>
          <div className="available-refferal-rewards">
            <div className="available-commission-rewards-top">
              <span>Referral Rewards</span>
              <div
                onClick={toggleModal1}
                className="available-commission-rewards-rules"
              >
                <img src="/assets/bcimages/bcaffiliate/alert-icon.svg" />
              </div>
            </div>
            <span className="available-commission-rewards-amount">
              ${rewards?.totalReferralReward}
            </span>
            {/* <div className='available-refferal-rewards-bottom'>
              <div className='refferal-total-received'>
                <span className='refferal-total-received-title'>Total Received</span>
                <span className='refferal-total-received-amount'>$0.00</span>
              </div>
              <div className='refferal-total-received'>
                <span className='refferal-total-received-title'>Total Received</span>
                <span className='refferal-total-received-amount'>$0.00</span>
              </div>
            </div> */}
          </div>
          {/* <div className="myrewards-swap-withdraw-buttons">
            <button disabled className="myrewards-swap-button">
              Swap
            </button>
            <button className="myrewards-withdrawtowallet-button">
              Withdraw to Wallet
            </button>
          </div> */}
          <div className="available-refferal-rewards">
            <div className="available-commission-rewards-top">
              <span>Deposit Commission</span>
              <div
                onClick={toggleModal1}
                className="available-commission-rewards-rules"
              >
                <img src="/assets/bcimages/bcaffiliate/alert-icon.svg" />
              </div>
            </div>
            <span className="available-commission-rewards-amount">
              ${rewards?.depositLevelBonusAmount}
            </span>
            {/* <div className='available-refferal-rewards-bottom'>
              <div className='refferal-total-received'>
                <span className='refferal-total-received-title'>Total Received</span>
                <span className='refferal-total-received-amount'>$0.00</span>
              </div>
              <div className='refferal-total-received'>
                <span className='refferal-total-received-title'>Total Received</span>
                <span className='refferal-total-received-amount'>$0.00</span>
              </div>
            </div> */}
          </div>
          <div className="available-refferal-rewards">
            <div className="available-commission-rewards-top">
              <span>Sign up Bonus</span>
              <div
                onClick={toggleModal1}
                className="available-commission-rewards-rules"
              >
                <img src="/assets/bcimages/bcaffiliate/alert-icon.svg" />
              </div>
            </div>
            <span className="available-commission-rewards-amount">
              ${userInfo?.total_signup_bonus_amount}
            </span>
            {/* <div className='available-refferal-rewards-bottom'>
              <div className='refferal-total-received'>
                <span className='refferal-total-received-title'>Total Received</span>
                <span className='refferal-total-received-amount'>$0.00</span>
              </div>
              <div className='refferal-total-received'>
                <span className='refferal-total-received-title'>Total Received</span>
                <span className='refferal-total-received-amount'>$0.00</span>
              </div>
            </div> */}
          </div>
        </div>

        <div className="myrewards-commission-refferal-table">
          <div className="commission-refferal-table-tabs">
            <button
              onClick={() => handleTabClick("commission")}
              className={activeTab === "commission" ? "active" : ""}
            >
              Commission
            </button>
            <button
              onClick={() => handleTabClick("referral")}
              className={activeTab === "referral" ? "active" : ""}
            >
              Referral
            </button>
            <button
              onClick={() => handleTabClick("deposit")}
              className={activeTab === "deposit" ? "active" : ""}
            >
              Deposit
            </button>
          </div>

          {/* Conditional rendering based on active tab */}
          {activeTab === "commission" ? (
            <>
              <div className="myrewards-refferal-table">
                <div className="refferal-table-data">
                  <table>
                    <thead>
                      <tr
                        className="refferal-table-header"
                        style={{ borderBottom: "1px solid #e4eaf019" }}
                      >
                        <th>Username</th>
                        <th>Date</th>
                        <th>VIP Level</th>
                        <th>Code</th>
                        <th>Bet amount</th>
                        <th>Bonus amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {betLevelCommisson.map((item, index) => (
                        <tr key={index} className="refferal-table-row">
                          <td>{item?.player_name}</td>
                          <td>{new Date(item.date).toLocaleString()}</td>
                          <td>{item.level}</td>
                          <td>{item.invite_code}</td>
                          <td>${item.bet.toFixed(2)}</td>
                          <td>${item.bonus_amt.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="rewards-activities-main-container">
                    <div className="bot-info">
                      <div className="d-flex flex-column justify-content-center align-items-center py-4 text-center">
                        <img
                          className="img-fluid"
                          style={{ width: "12rem", height: "12rem" }}
                          src="\assets\bcimages\bcaffiliate\reward-activity-empty.webp"
                          alt="Empty"
                        />
                        <div className="reward-activities-font mt-4 text-center">
                          <p>No rewards yet. Invite friends to join you now!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : activeTab === "deposit" ? (
            <div className="myrewards-refferal-table">
              {/* <div className="refferal-table-date-range">
                <div className="date-range-input">
                  <div className="date-range-input-inner">
                    <label
                      style={{ marginBottom: "0px", whiteSpace: "nowrap" }}
                    >
                      Registration Date:
                    </label>
                    <div className="date-range-input-field">
                      <ReactDatePicker
                        className="date-picker-input-filed"
                        selected={startDate}
                        onChange={(dates) => {
                          setStartDate(dates[0]);
                          setEndDate(dates[1]);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        placeholderText="All Range"
                        dateFormat="yyyy-MM-dd"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="refferal-table-data">
                <table>
                  <thead>
                    <tr
                      className="refferal-table-header"
                      style={{ borderBottom: "1px solid #e4eaf019" }}
                    >
                      <th>Username</th>
                      <th>Registration Date</th>
                      <th>VIP Level</th>
                      <th>Code</th>
                      <th>Deposit</th>
                      <th className="">Bonus</th>
                    </tr>
                  </thead>
                  <tbody>
                      {depositLevelCommisson.map((item, index) => (
                        <tr key={index} className="refferal-table-row">
                          <td>{item.player_name}</td>
                          <td>{new Date(item.date).toLocaleString()}</td>
                          <td>{item.level}</td>
                          <td>{item.invite_code}</td>
                          <td>${item.deposit.toFixed(2)}</td>
                          <td>${item.bonus_amt.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                </table>
                <div className="rewards-activities-main-container">
                  <div className="bot-info">
                    <div className="d-flex flex-column justify-content-center align-items-center py-4 text-center">
                      <img
                        className="img-fluid"
                        style={{ width: "12rem", height: "12rem" }}
                        src="\assets\bcimages\bcaffiliate\reward-activity-empty.webp"
                        alt="Empty"
                      />
                      <div className="reward-activities-font mt-4 text-center">
                        <p>No rewards yet. Invite friends to join you now!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="myrewards-refferal-table">
              {/* <div className="refferal-table-date-range">
                <div className="date-range-input">
                  <div className="date-range-input-inner">
                    <label
                      style={{ marginBottom: "0px", whiteSpace: "nowrap" }}
                    >
                      Registration Date:
                    </label>
                    <div className="date-range-input-field">
                      <ReactDatePicker
                        className="date-picker-input-filed"
                        selected={startDate}
                        onChange={(dates) => {
                          setStartDate(dates[0]);
                          setEndDate(dates[1]);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        placeholderText="All Range"
                        dateFormat="yyyy-MM-dd"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="refferal-table-data">
                <table>
                  <thead>
                    <tr
                      className="refferal-table-header"
                      style={{ borderBottom: "1px solid #e4eaf019" }}
                    >
                      <th>Username</th>
                      {/* <th>Registration Date</th>
                      <th>VIP Level</th>
                      <th>Code</th> */}
                      <th className="">Earned</th>
                      <th className="">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                      {members?.map((item, index) => (
                        <tr key={index} className="refferal-table-row">
                          {/* <td>{item.name_user}</td> */}
                        
                          <td>{item.membername}</td>
                          <td>{item.total_commission}</td>
                          <td>{new Date().toLocaleString()}</td>
                          {/* <td>${item.bet.toFixed(2)}</td>
                          <td>${item.bonus_amt.toFixed(2)}</td> */}
                        </tr>
                      ))}
                    </tbody>
                </table>
                <div className="rewards-activities-main-container">
                  <div className="bot-info">
                    <div className="d-flex flex-column justify-content-center align-items-center py-4 text-center">
                      <img
                        className="img-fluid"
                        style={{ width: "12rem", height: "12rem" }}
                        src="\assets\bcimages\bcaffiliate\reward-activity-empty.webp"
                        alt="Empty"
                      />
                      <div className="reward-activities-font mt-4 text-center">
                        <p>No rewards yet. Invite friends to join you now!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <div className="rules-history-button">
            <Link to="/affiliate/rate-and-rules">
              <button className="rule_btn">
                <img src="/assets/bcimages/bcaffiliate/rules_icon.svg" />
                <span>Rules</span>
              </button>
            </Link>
            <button onClick={handleHistoryClick} className="rule_btn">
              <img src="/assets/bcimages/bcaffiliate/history_icon.svg" />
              <span>History</span>
              <MdKeyboardArrowRight size={18} />
            </button>
          </div> */}
          <div className="commission-refferal-table-border"></div>
        </div>
      </div>

      {/* Modal Components */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Referral Terms & Conditions"
        className="commision-rule"
        overlayClassName="custom-overlay"
      >
        <h2>Commission Rewards</h2>
        <button onClick={toggleModal} className="close-modal-button">
          <RxCross2 />
        </button>
        <div className="modal-content-affiliate">
          <h3>Available Commission Rewards</h3>
          <p>The rewards you can withdraw to your wallet.</p>
          <h3>Total received</h3>
          <p>
            The rewards you have received up to now. It includes the rewards
            already withdrawn and the available commission rewards.
          </p>
        </div>
      </Modal>

      {/* Referral Modal Component */}
      <Modal
        isOpen={isModalOpen1}
        onRequestClose={toggleModal1}
        contentLabel="Referral Terms & Conditions"
        className="refferal-rule"
        overlayClassName="custom-overlay"
      >
        <h2>Referral Rewards</h2>
        <button onClick={toggleModal1} className="close-modal-button">
          <RxCross2 />
        </button>
        <div className="modal-content-affiliate">
          <h3>Available Referral Rewards</h3>
          <p>The rewards you can withdraw to your wallet.</p>
          <h3>Total received</h3>
          <p>
            All unlocked rewards received so far, including withdrawn and
            available for withdrawal.
          </p>
          <h3>Locked Rewards</h3>
          <p>
            The rewards that you will receive in the future when your friends’
            VIP level increases.
          </p>
        </div>
      </Modal>

      {/* History modal Components */}
      <Modal
        isOpen={historyModal}
        onRequestClose={handleHistoryClick}
        contentLabel="Referral Terms & Conditions"
        className="reffral-commission-history"
        overlayClassName="custom-overlay"
      >
        <h2>Reward History</h2>
        <button onClick={handleHistoryClick} className="close-modal-button">
          <RxCross2 />
        </button>
        <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
          <div className="refferal-commission-history-modal" ref={dropdownRef}>
            <button
              style={{ marginTop: "20px" }}
              onClick={toggleOptions}
              className="main-select-button"
            >
              {selectedOption}
              <div className="calculate-game-select">
                <MdKeyboardArrowDown size={20} />
              </div>
            </button>
            {isOptionsVisible && (
              <div className="history-select-options">
                <div className="games-select-container">
                  {options.map((option) => (
                    <button
                      className={`games-select-button ${
                        selectedOption === option.label ? "active" : ""
                      }`}
                      onClick={() => handleOptionClick(option)}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div style={{ marginTop: "20px" }} className="refferal-table-data">
            <table>
              <thead>
                <tr
                  className="refferal-table-header"
                  style={{ borderBottom: "1px solid #e4eaf019" }}
                >
                  <th>Currency</th>
                  <th>Amount</th>
                  <th>Time</th>
                  <th className="text-right">Status</th>
                </tr>
              </thead>
            </table>

            <div className="bot-info">
              <div className="d-flex flex-column justify-content-center align-items-center py-4 text-center">
                <img
                  className="img-fluid"
                  style={{ width: "12rem", height: "12rem" }}
                  src="\assets\bcimages\bcaffiliate\reward-activity-empty.webp"
                  alt="Empty"
                />
                <div className="reward-activities-font mt-4 text-center">
                  <p>Oops! There is no data yet!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MyRewards;
